import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import EnglishIsLekka from "@/pages/EnglishIsLekka";
import Workshops from "@/pages/Workshops";
import ClubPage from "@/pages/ClubPage";
import EduPower13 from "@/pages/EduPower13";
import Wellbeing from "@/pages/Wellbeing";
import Team from "@/pages/Team";
import Events from "@/pages/Events";
import AdminLogin from "@/pages/AdminLogin";
import AdminReset from "@/pages/AdminReset";
import Admin from "@/pages/Admin";
import DonateSuccess from "@/pages/DonateSuccess";
import DonateCancel from "@/pages/DonateCancel";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

const ScrollManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/english-is-lekka" element={<EnglishIsLekka />} />
            <Route path="/english-is-lekka/workshops" element={<Workshops />} />
            <Route path="/english-is-lekka/clubs/:slug" element={<ClubPage />} />
            <Route path="/edupower13" element={<EduPower13 />} />
            <Route path="/wellbeing" element={<Wellbeing />} />
            <Route path="/team" element={<Team />} />
            <Route path="/events" element={<Events />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset-password" element={<AdminReset />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/donate/success" element={<DonateSuccess />} />
            <Route path="/donate/cancel" element={<DonateCancel />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
